import * as React from "react";
import { Helmet } from "react-helmet";
import { IMetaData } from "../../../shared/interface/article";
import metaContent from "../cms/meta.json";

export interface IHeadProps {
  metaData?: IMetaData;
}

const headElementSelectors = [
  "meta[name='description']",
  "link[rel='canonical']",
  "title",
];

// adds data attributes to elements from outside our app
// so that helmet can modify them
const helmetify = (selector: string) =>
  document.querySelector(selector)?.setAttribute("data-react-helmet", "true");

export class Head extends React.Component<IHeadProps> {
  constructor(props) {
    super(props);

    headElementSelectors.map(helmetify);
  }

  render() {
    const metaData = this.props.metaData;
    const metaTitle = metaData?.metaTitle
      ? `${metaData?.metaTitle}${metaContent.titleSuffix}`
      : metaContent.defaultTitle;
    const metaDescription =
      metaData?.metaDescription || metaContent.defaultDescription;
    return (
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        {metaData?.canonicalUrl && (
          <link rel="canonical" href={metaData.canonicalUrl} />
        )}
      </Helmet>
    );
  }
}
